import "/__w/1/s/BotFramework-WebChat/packages/component/src/decorator/private/BorderFlair.module_built.css";
const classes = {"border-flair--complete":"wEWpITq_border-flair--complete","border-flair":"wEWpITq_border-flair"}
export default classes

const _border_flair__complete0 = classes["border-flair--complete"]
export { _border_flair__complete0 as "border-flair--complete" }

const _border_flair0 = classes["border-flair"]
export { _border_flair0 as "border-flair" }
